import { ViewWeek } from "@mui/icons-material";
import { getMasterData, getInterlinkagesMasterData } from "Samarth Module/api/api";

export const getFilterDetails = async (alertType, viewType, userEmail, filterData) => {
    try {
        const cacheKey = viewType === 'MAI View' || viewType === 'FG Coverage'  || viewType === 'Open PO Details' || viewType === 'Stock to Norm' ? `filterData_${viewType}` : `filterData_${alertType}`;
        const isFilterDataEmpty = !filterData || Object.keys(filterData).length === 0;

        // If filterData is empty, use existing cache logic
        if (isFilterDataEmpty) {
            const cachedData = localStorage.getItem(cacheKey);
            if (cachedData) {
                return JSON.parse(cachedData);
            }

            const response = await getMasterData(
                viewType === 'MAI View' ? 'MAI' : viewType === 'FG Coverage' ? 'FG Coverage' : viewType === 'Open PO Details'? 'OpenPO Details': viewType === 'Stock to Norm' ? 'Norm Alert' : alertType,
                userEmail
            );
            if (response) {
                const dataToStore = {
                    data: response,
                    timestamp: new Date().getTime()
                };
                localStorage.setItem(cacheKey, JSON.stringify(dataToStore));
                return { data: response };
            }
        } else {
            // If filterData has selections, clear cache and call getInterlinkagesMasterData
            localStorage.removeItem(cacheKey);

            const type = viewType === 'MAI View' ? 'MAI' : viewType === 'FG Coverage' ? 'FG Coverage' : viewType==='Open PO Details'?'OpenPO Details': viewType === 'Stock to Norm' ? 'Norm Alert' : alertType;
            const response = await getInterlinkagesMasterData(type, { selected_filters: filterData, userEmail });

            if (response) {
                const dataToStore = {
                    data: response,
                    timestamp: new Date().getTime()
                };
                // localStorage.setItem(cacheKey, JSON.stringify(dataToStore));
                return { data: response };
            }
        }
    } catch (error) {
        console.error('Persona API error:', error);
        return null;
    }
}

export const cleanupCache = () => {
    const oneDay = 24 * 60 * 60 * 1000;
    const now = new Date().getTime();

    Object.keys(localStorage).forEach(key => {
        if (key.startsWith('filterData_')) {
            try {
                const cachedData = JSON.parse(localStorage.getItem(key));
                if (!cachedData || (now - cachedData.timestamp) > oneDay) {
                    localStorage.removeItem(key);
                }
            } catch (e) {
                console.error('Error cleaning cache for key:', key, e);
                localStorage.removeItem(key);
            }
        }
    });
};

export const scheduleCleanup = () => {
    cleanupCache();
    const now = new Date();

    // Schedule every 3 hours
    const hours = now.getHours();
    const nextInterval = new Date(now);

    const nextHour = Math.ceil(hours / 3) * 3;
    if (nextHour >= 24) {
        nextInterval.setDate(nextInterval.getDate() + 1);
        nextInterval.setHours(0, 0, 0, 0);
    } else {
        nextInterval.setHours(nextHour, 0, 0, 0);
    }

    const timeUntilNext = nextInterval - now;

    setTimeout(() => {
        cleanupCache();
        setInterval(cleanupCache, 3 * 60 * 60 * 1000);
    }, timeUntilNext);

    // Schedule daily at 11:45 AM
    const elevenFortyFive = new Date();
    elevenFortyFive.setHours(11, 45, 0, 0);

    // If it's already past 11:45 today, schedule for tomorrow
    if (now > elevenFortyFive) {
        elevenFortyFive.setDate(elevenFortyFive.getDate() + 1);
    }

    const timeUntil1145 = elevenFortyFive - now;

    setTimeout(() => {
        cleanupCache();
        // Set daily interval
        setInterval(() => {
            cleanupCache();
        }, 24 * 60 * 60 * 1000);
    }, timeUntil1145);
};
